import { ShowInventory } from "components/Protected/Inventory/ShowInventory";

export function ShowInventoryPage() {
  return <ShowInventory />
}

